import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { AdminHeaderComponent } from './components/admin-header/admin-header.component';
// Declared here, not in AppModule: AdminHeaderComponent renders it, and AOT builds fail otherwise.
import { PageContentComponent } from '../layout/page-content/page-content.component';
import { SuccessComponent } from './modals/success/success.component';
import { ErrorComponent } from './modals/error/error.component';
import { ResponseComponent } from './modals/response/response.component';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { CameraComponent } from './modals/camera/camera.component';
import { SignaturePadComponent } from './modals/signature-pad/signature-pad.component';
import { ViewIdComponent } from './components/view-id/view-id.component';
import { SoloParentIdTemplateComponent } from './components/templates/solo-parent-id-template/solo-parent-id-template.component';
import { PwdIdTemplateComponent } from './components/templates/pwd-id-template/pwd-id-template.component';
import { UtcToLocalPipe } from '../pipes/utc-to-local.pipe';
import { ViewSpIdComponent } from './components/view-sp-id/view-sp-id.component';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CropOverlayDirective } from '../directives/crop-overlay.directive';
import { DownloadDirective } from '../directives/download.directive';
import { LoadingSpinnerComponent } from './modals/loading-spinner/loading-spinner.component';
import { VoucherListComponent } from './modals/voucher-list/voucher-list.component';

export const maskConfig: Partial<IConfig> = {
  dropSpecialCharacters: false // keep dashes in value
};

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
    PageContentComponent,
    SuccessComponent,
    ErrorComponent,
    ResponseComponent,
    LineChartComponent,
    PieChartComponent,
    CameraComponent,
    SignaturePadComponent,
    ViewIdComponent,
    SoloParentIdTemplateComponent,
    PwdIdTemplateComponent,
    UtcToLocalPipe,
    ViewSpIdComponent,
    CropOverlayDirective ,
    DownloadDirective,
    LoadingSpinnerComponent,
    VoucherListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    MatDatetimepickerModule,
    MatNativeDatetimeModule,
    MatDatepickerModule,
    NgxMatTimepickerModule.setLocale('en-GB'),
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    NgApexchartsModule,
    NgxMaskModule.forRoot(maskConfig),
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
    PageContentComponent,
    LineChartComponent,
    PieChartComponent,
    ViewIdComponent,
    SoloParentIdTemplateComponent,
    PwdIdTemplateComponent,
    ViewSpIdComponent,
    UtcToLocalPipe,
    CropOverlayDirective,
    DownloadDirective
  ]
})
export class SharedModule { }
